import React from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles } from "tss-react/mui";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    Accordion,
    AccordionSummary,
} from "@mui/material";
import {
    Container,
    TextField,
    Button,
    Typography,
    Paper,
    Grid,
} from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { userService } from "./services/user_functions";
import Loading from "./Loading";
import { authenticationService } from "./services/auth_service";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

/* ESSA PARTE DO CÓDIGO FOI TIRADA DE https://material-ui.com/components/tables/ COM ALTERAÇÕES */

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: "prMotherFirstname",
        numeric: false,
        disablePadding: false,
        label: "Nome da mãe",
    },
    {
        id: "prMotherLastname",
        numeric: false,
        disablePadding: false,
        label: "Sobrenome da mãe",
    },
    {
        id: "HospitalNasc",
        numeric: false,
        disablePadding: false,
        label: "Hospital Nascimento",
    },
    {
        id: "DataNasc",
        numeric: false,
        disablePadding: false,
        label: "Data nascimento",
    },
    { id: "DNV", numeric: false, disablePadding: false, label: "DNV" },
    { id: "CNS", numeric: false, disablePadding: false, label: "CNS" },
    {
        id: "ptnFirstname",
        numeric: false,
        disablePadding: false,
        label: "Nome da criança",
    },
    {
        id: "ptnSurname",
        numeric: false,
        disablePadding: false,
        label: "Sobrenome da criança",
    },
    {
        id: "LocalColeta",
        numeric: false,
        disablePadding: false,
        label: "Local coleta",
    },
    {
        id: "DataColeta",
        numeric: false,
        disablePadding: false,
        label: "Data coleta",
    },
    { id: "CPF", numeric: false, disablePadding: false, label: "CPF da mãe" },
    {
        id: "PDF_ImageDate",
        numeric: false,
        disablePadding: false,
        label: "Data Emissão",
    },
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox"></TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align="left"
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : "asc"}
                            onClick={createSortHandler(headCell.id)}
                        >
                            <b>{headCell.label}</b>
                            {/* {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === "desc"
                                        ? "sorted descending"
                                        : "sorted ascending"}
                                </span>
                            ) : null}*/}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles()((theme) => ({
    root: {
        width: "100%",
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        top: 20,
        width: 1,
    },
    cell: {
        whiteSpace: "nowrap",
    },
}));

function EnhancedTable(props) {
    const { rows } = props;
    const classes = useStyles();

    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("ordering");
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    // ao filtrar, retorna à primeira página
    useEffect(() => {
        setPage(0);
    }, [props.rows]);

    if (rows === []) return <Loading />;
    else {
        const handleRequestSort = (event, property) => {
            const isAsc = orderBy === property && order === "asc";
            setOrder(isAsc ? "desc" : "asc");
            setOrderBy(property);
        };

        const handleSelectAllClick = (event) => {
            if (event.target.checked) {
                const newSelecteds = rows.map((n) => n.name);
                setSelected(newSelecteds);
                return;
            }
            setSelected([]);
        };

        const handleClick = (event, name) => {
            const selectedIndex = selected.indexOf(name);
            let newSelected = [];

            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, name);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    selected.slice(0, selectedIndex),
                    selected.slice(selectedIndex + 1),
                );
            }

            setSelected(newSelected);
        };

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };

        const downloadFile = (PDF_Filename, nomeMae, sobrenomeMae) => {
            // if (
            //   /CriOS/i.test(navigator.userAgent) &&
            //   /iphone|ipod|ipad/i.test(navigator.userAgent)
            // ) {
            //   // userService.downloadFile(this.props.child.PDF_Filename).then(response => {
            //   userService.downloadFile(PDF_Filename).then(response => {
            //       const fileURL = URL.createObjectURL(new Blob([response.data, 'TesteDoPezinho.pdf'], {type: 'application/pdf'}))
            //       window.open(fileURL, 'TesteDoPezinho.pdf')

            // //   }).catch(e => window.alert("Não foi possível obter o arquivo."))
            // } else {
            const FileDownload = require("js-file-download");
            userService
                .downloadFile(PDF_Filename)
                .then((response) => {
                    //FileDownload(response.data, `resultado_${nomeMae}${sobrenomeMae}_${PDF_Filename}.pdf`);
                    FileDownload(response.data, PDF_Filename);
                })
                .catch((e) =>
                    window.alert("Não foi possível obter o arquivo."),
                );
            // }
        };

        const isSelected = (name) => selected.indexOf(name) !== -1;

        const emptyRows =
            rowsPerPage -
            Math.min(rowsPerPage, rows.length - page * rowsPerPage);

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size="medium"
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                            />
                            <TableBody>
                                {stableSort(rows, getComparator(order, orderBy))
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage,
                                    )
                                    .map((row, index) => {
                                        const isItemSelected = isSelected(
                                            row.IDExport,
                                        );

                                        return (
                                            <TableRow
                                                hover
                                                onClick={(event) =>
                                                    handleClick(
                                                        event,
                                                        row.IDExport,
                                                    )
                                                }
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.IDExport}
                                                selected={isItemSelected}
                                            >
                                                <TableCell
                                                    variant="body"
                                                    className={classes.cell}
                                                    padding="checkbox"
                                                >
                                                    <Button
                                                        sx={{ color: "black" }}
                                                        onClick={() =>
                                                            downloadFile(
                                                                row.PDF_Filename,
                                                                row.prMotherFirstname,
                                                                row.prMotherSurname,
                                                            )
                                                        }
                                                    >
                                                        <GetAppIcon />
                                                    </Button>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    {" "}
                                                    <Typography noWrap>
                                                        {row.prMotherFirstname}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.prMotherSurname}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.HospitalNasc}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.DataNasc === null
                                                            ? ""
                                                            : new Date(
                                                                  row.DataNasc,
                                                              ).toLocaleDateString(
                                                                  "pt-BR",
                                                                  {
                                                                      timeZone:
                                                                          "UTC",
                                                                  },
                                                              )}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    component="th"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.DNV}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.CNS}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.ptnFirstname}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.ptnSurname}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.LocalColeta}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.DataColeta === null
                                                            ? ""
                                                            : new Date(
                                                                  row.DataColeta,
                                                              ).toLocaleDateString(
                                                                  "pt-BR",
                                                                  {
                                                                      timeZone:
                                                                          "UTC",
                                                                  },
                                                              )}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="left"
                                                >
                                                    <Typography noWrap>
                                                        {row.CPF}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    size="medium"
                                                    variant="body"
                                                    className={classes.cell}
                                                    align="right"
                                                >
                                                    <Typography noWrap>
                                                        {row.PDF_ImageDate ===
                                                        null
                                                            ? ""
                                                            : new Date(
                                                                  row.PDF_ImageDate,
                                                              ).toLocaleDateString(
                                                                  "pt-BR",
                                                                  {
                                                                      timeZone:
                                                                          "UTC",
                                                                  },
                                                              )}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow
                                        variant="body"
                                        style={{ height: 53 * emptyRows }}
                                    >
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        labelDisplayedRows={({ from, to, count }) =>
                            `Mostrando ${from}-${to} de ${count} itens.`
                        }
                        labelRowsPerPage="Itens por página:"
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
                <Typography>
                    Neste portal, estão disponíveis os resultados do Teste do
                    Pezinho emitidos a partir de 20/11/2021. Para exames
                    anteriores a esta data, entre em contato com o Laboratório
                    de Triagem do CIPOI pelo e-mail: triagem1@unicamp.br.
                </Typography>
                {/* <Typography>Exames de investigação familiar para Hemoglobinopatias não estão disponíveis através desta plataforma.</Typography> */}
            </div>
        );
    }
}

const useStyles2 = (theme, props) => ({
    paper: {
        marginTop: theme.spacing(3),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
    },

    grid: {
        // marginTop: theme.spacing(1),
        // marginBottom: theme.spacing(1),
    },
    filtrosHeader: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    table: {
        // width: "100%",
        // minWidth: 700,
        alignItems: "stretch",
        justifyContent: "space-evenly",
    },
    tableitem: {
        // width: '200px',
        height: "100%",
    },
    tableitem_m: {
        width: "10%",
        // border:'1px solid green'
    },
});

/* FIM DA PARTE IMPORTADA*/

const sx = {
    grid: {
        justifyContent: "space-evenly",
        alignItems: "stretch",
        marginTop: 1,
        marginBottom: 1,
    },
    gridItem: {
        display: "flex",
        justifyContent: "right",
        alignItems: "center",
        // border: "1px solid red",
    },
};

class Employee extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: this.props.userData,
            rows: [],
            cns: "",
            cpf: "",
            dnv: "",
            firstName: "",
            lastName: "",
            birthday: null,
            birthPlace: "",
            collPlace: "",
            collDay: null,
            // CodHNasc: '',
            CodLCol: "",
            PDF_ImageDate: null,
        };
    }

    limparFiltros = () => {
        document.getElementById("dnv").value = "";
        document.getElementById("cns").value = "";
        document.getElementById("cpf").value = "";
        document.getElementById("firstName").value = "";
        document.getElementById("lastName").value = "";
        // document.getElementById('birthday').value = null
        document.getElementById("birthPlace").value = "";
        document.getElementById("collPlace").value = "";
        // document.getElementById('collDay').value = null
        // document.getElementById('CodHNasc').value = ""
        document.getElementById("CodLCol").value = "";
        // document.getElementById('PDF_ImageDate').value = null

        setTimeout(() => {
            this.setState(
                {
                    dnv: "",
                    cns: "",
                    cpf: "",
                    firstName: "",
                    lastName: "",
                    birthday: null,
                    birthPlace: "",
                    collPlace: "",
                    collDay: null,
                    // CodHNasc: '',
                    CodLCol: "",
                    PDF_ImageDate: null,
                },
                () => {
                    this.listResults();
                },
            );
        }, 10);
    };

    listResults = () => {
        const dates = {
            nascimento: this.state.birthday,
            coleta: this.state.collDay,
            emissão: this.state.PDF_ImageDate,
        };
        for (const [key, date] of Object.entries(dates)) {
            if (
                date &&
                (!date?.isValid() ||
                    date?.isBefore(dayjs("1900-01-01"), "year"))
            ) {
                window.alert(`Data de ${key} deve ser uma data válida`);
                return;
            }
        }
        userService
            .listResults(
                this.state.cns,
                this.state.cpf,
                this.state.dnv,
                this.state.firstName,
                this.state.lastName,
                this.state.birthday?.format("DD-MM-YYYY") || "",
                this.state.birthPlace,
                this.state.collPlace,
                this.state.collDay?.format("DD-MM-YYYY") || "",
                this.state.CodLCol,
                this.state.PDF_ImageDate?.format("DD-MM-YYYY") || "",
            )
            .then((response) => {
                // , this.state.birthPlace, this.state.collPlace, this.state.collDay, this.state.CodHNasc, this.state.CodLCol).then(response => {

                this.setState({ rows: response.data });
            })
            .catch((e) => {
                window.alert(
                    "A sua sessão expirou. Entre com seus dados novamente.",
                );
                authenticationService.logout();
                this.props.history.push("/");
            });
    };
    componentDidMount() {

        // setState assíncrono: callback garante CodLCol atualizado antes de listResults() - Antes do botão Filtrar
        if (this.props.userData.is_staff && !this.props.userData.is_superuser) {
            //funcionario LocalColeta
            this.setState({ CodLCol: this.props.userData.login }, // 1º argumento: o dado a atualizar
            () => {this.listResults()}                            // 2º argumento: o callback
            );
        } else if (
            this.props.userData.is_staff &&
            this.props.userData.is_superuser
        ) {
            //Admin
            this.listResults();
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <Container style={{ padding: "0px", paddingBottom: "30px" }}>
                {/* <Typography variant="h6" className={classes.grid}>Bem vindo(a), {this.props.userData.name}</Typography> */}
                <Accordion className={classes.grid}>
                    <AccordionSummary
                        className={classes.filtrosHeader}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography
                            variant="button"
                            className={classes.heading}
                        >
                            <b>Filtros</b>
                        </Typography>
                    </AccordionSummary>
                    <Grid container sx={sx.grid} spacing={0.5}>
                        <Grid sx={sx.gridItem} size={2}>
                            <Typography>Nome da mãe:</Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2}>
                            <TextField
                                size="small"
                                id="firstName"
                                onChange={(e) =>
                                    this.setState({
                                        firstName: e.target.value,
                                    })
                                }
                                slotProps={{
                                    htmlInput: { maxLength: 100 },
                                }}
                            />
                        </Grid>
                        <Grid sx={sx.gridItem} size={1.5}>
                            <Typography noWrap>Data de emissão:</Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2.5}>
                            <DatePicker
                                minDate={dayjs("1900-01-01")}
                                disableFuture
                                label="dd/mm/aaaa"
                                id="PDF_ImageDate"
                                format="DD/MM/YYYY"
                                value={this.state.PDF_ImageDate}
                                onChange={(newvalue) =>
                                    this.setState({
                                        PDF_ImageDate: newvalue,
                                    })
                                }
                                slotProps={{ textField: { size: "small" } }}
                            />{" "}
                        </Grid>
                        <Grid sx={sx.gridItem} size={1.5}>
                            <Typography align="right">CPF da mãe:</Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2.5}>
                            <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                id="cpf"
                                onChange={(e) =>
                                    this.setState({
                                        cpf: e.target.value,
                                    })
                                }
                                slotProps={{
                                    htmlInput: { maxLength: 11 },
                                }}
                            />
                        </Grid>
                        {/* ==================================================*/}
                        <Grid sx={sx.gridItem} size={2}>
                            <Typography align="right">
                                Último sobrenome da mãe:
                            </Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2}>
                            <TextField
                                size="small"
                                id="lastName"
                                onChange={(e) =>
                                    this.setState({
                                        lastName: e.target.value,
                                    })
                                }
                                slotProps={{
                                    htmlInput: { maxLength: 100 },
                                }}
                            />
                        </Grid>
                        <Grid sx={sx.gridItem} size={4} />
                        <Grid sx={sx.gridItem} size={1.5}>
                            <Typography> DNV:</Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2.5}>
                            <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                id="dnv"
                                onChange={(e) =>
                                    this.setState({
                                        dnv: e.target.value,
                                    })
                                }
                                slotProps={{
                                    htmlInput: { maxLength: 13 },
                                }}
                            />
                        </Grid>
                        {/* ====================================================*/}
                        <Grid sx={sx.gridItem} size={2}>
                            <Typography>Hospital de Nascimento:</Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2}>
                            <TextField
                                size="small"
                                id="birthPlace"
                                onChange={(e) =>
                                    this.setState({
                                        birthPlace: e.target.value,
                                    })
                                }
                                slotProps={{
                                    htmlInput: { maxLength: 100 },
                                }}
                            />
                        </Grid>
                        <Grid sx={sx.gridItem} size={4} />
                        <Grid sx={sx.gridItem} size={1.5}>
                            <Typography>CNS:</Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2.5}>
                            <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                id="cns"
                                onChange={(e) =>
                                    this.setState({
                                        cns: e.target.value,
                                    })
                                }
                                slotProps={{
                                    htmlInput: { maxLength: 15 },
                                }}
                            />
                        </Grid>
                        {/* ====================================================*/}

                        <Grid sx={sx.gridItem} size={2}>
                            <Typography>Local de coleta:</Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2}>
                            <TextField
                                size="small"
                                id="collPlace"
                                onChange={(e) =>
                                    this.setState({
                                        collPlace: e.target.value,
                                    })
                                }
                                slotProps={{
                                    htmlInput: { maxLength: 100 },
                                }}
                            />
                        </Grid>
                        <Grid sx={sx.gridItem} size={1.5}>
                            <Typography>Cód. Loc Coleta:</Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2.5}>
                            <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                id="CodLCol"
                                defaultValue={this.props.userData.login}
                                onChange={(e) =>
                                    this.setState({
                                        CodLCol: e.target.value,
                                    })
                                }
                                slotProps={{
                                    htmlInput: { maxLength: 5 },
                                }}
                            />
                        </Grid>
                        <Grid sx={sx.gridItem} size={1.5}>
                            <Typography align="right">
                                Data de nascimento:
                            </Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2.5}>
                            <DatePicker
                                minDate={dayjs("1900-01-01")}
                                disableFuture
                                label="dd/mm/aaaa"
                                id="PDF_ImageDate"
                                format="DD/MM/YYYY"
                                value={this.state.birthday}
                                onChange={(newvalue) =>
                                    this.setState({
                                        birthday: newvalue,
                                    })
                                }
                                slotProps={{ textField: { size: "small" } }}
                            />
                        </Grid>
                        <Grid sx={sx.gridItem} size={8} />
                        <Grid sx={sx.gridItem} size={1.5}>
                            <Typography align="right">
                                Data da coleta:
                            </Typography>
                        </Grid>
                        <Grid sx={sx.gridItem} size={2.5}>
                            <DatePicker
                                minDate={dayjs("1900-01-01")}
                                label="dd/mm/aaaa"
                                id="PDF_ImageDate"
                                format="DD/MM/YYYY"
                                value={this.state.collDay}
                                onChange={(newvalue) =>
                                    this.setState({
                                        collDay: newvalue,
                                    })
                                }
                                slotProps={{ textField: { size: "small" } }}
                            />
                        </Grid>
                        {/* ====================================================*/}
                        <Grid sx={sx.gridItem} size={2}>
                            <Button
                                variant="contained"
                                onClick={this.listResults}
                            >
                                FILTRAR
                            </Button>
                        </Grid>
                        <Grid size={2} />
                        <Grid
                            sx={{ ...sx.gridItem, justifyContent: "left" }}
                            size={"grow"}
                        >
                            <Button
                                variant="contained"
                                onClick={this.limparFiltros}
                            >
                                LIMPAR BUSCA
                            </Button>
                        </Grid>
                    </Grid>
                </Accordion>
                <EnhancedTable rows={this.state.rows} />
            </Container>
        );
    }
}

export default withStyles(Employee, useStyles2);

